import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { isObjectEmpty } from '../../Utils';
import { classExpression } from '@babel/types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function DialogClassList({dialogState}) {

    const {dialog, setDialog, classID} = dialogState;    
    const {title, classes, show, processSelectedClass} = dialog;
    const [classData, setClassData] = useState([]);

    useEffect(()=>{
        if(classes && classData.length ===0)
            setClassData(classes.sort((a,b) => (a.Classname.toUpperCase() > b.Classname.toUpperCase()) ? 1 : (a.Classname.toUpperCase() < b.Classname.toUpperCase() ? -1 : 0)));
    });

    const hasSelection=()=>{
        if(classData.length > 0){
            return classData.find(e=>e.isSelected)?true:false;
        }
        return false;
    };
    const saveHandler=()=>{
        if(hasSelection()){
            processSelectedClass(classData.find(e=>e.isSelected));
            setDialog({show:false});
        }
    };
    const closeHandler=()=>{
        setDialog({show:false});
    };

    return (
        <>
        <Modal show={show} onHide={closeHandler}>
            <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div style={{overflowY:'scroll', overflowX : 'hidden',height:'300px', padding:'10px', border: '1px solid #cfcfcf'}}>
            {classData.map((classRec, i) => 
                <ClassRow key={i} mainClassID={classID} classRec={classRec} classData={classData} setClassData={setClassData}/>
            )}
            </div>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={closeHandler}>
                Close
            </Button>
            <Button variant="primary" disabled={!hasSelection()} onClick={saveHandler}>
                Choose
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

const ClassRow = ({classRec, mainClassID, classData, setClassData}) => {
    const {Classname, ClassID, isSelected} = classRec;

    const selectClass=(classID)=>{
        if(mainClassID === ClassID) return;
        let nextState = classData.map(e=>{return {...e, isSelected:false};});
        let classIdx = nextState.findIndex(el => el.ClassID === classID);
        nextState[classIdx].isSelected = true;
        setClassData(nextState);    
    }; 

    const rowStyle = {
        backgroundColor: (isSelected ? 'lightblue' : 'white'), 
        margin: '2px', 
        cursor: 'pointer',
        borderBottom: '1px solid #cfcfcf'
    };
    
    const disabledStyle = {
        backgroundColor: (isSelected ? 'lightblue' : 'white'), 
        margin: '2px', 
        color: 'red',
        borderBottom: '1px solid #cfcfcf'
    };    

    return (
        <>
            <Row style={(mainClassID !== ClassID) ? rowStyle : disabledStyle} onClick={()=>selectClass(ClassID)}>
                <Col style={{textAlign: 'left'}} xs='6'> {Classname} </Col>
            </Row>
        </>
    );
};

export default DialogClassList;